/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentNotificationWebHook {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("WellArchitectedFrameworkAssessmentNotificationWebHook");
    }

    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentNotificationWebHook.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHook>): WellArchitectedFrameworkAssessmentNotificationWebHook {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentNotificationWebHook(), model);
        WellArchitectedFrameworkAssessmentNotificationWebHook.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentNotificationWebHook>): WellArchitectedFrameworkAssessmentNotificationWebHook {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentNotificationWebHook.newInstance(<WellArchitectedFrameworkAssessmentNotificationWebHook> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHook) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentNotificationWebHook.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentNotificationWebHook): boolean {
        switch (obj.__type)
        {
            case "WellArchitectedFrameworkAssessmentNotificationWebHook":
                Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentNotificationWebHook.prototype);
                break;
            case "WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams":
                Object.setPrototypeOf(obj, models.WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams.prototype);
                break;
            case "WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType":
                Object.setPrototypeOf(obj, models.WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof WellArchitectedFrameworkAssessmentNotificationWebHook)[] {
        return [
            models.WellArchitectedFrameworkAssessmentNotificationWebHookForMicrosoftTeams,
            models.WellArchitectedFrameworkAssessmentNotificationWebHookForStandardType,
        ];
    }

    fixupFields() {
    }

    /**
     * Webhook ID to trigger notification
     */
    webhook_id: string;

}
